import React, { useEffect, useState } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import ALL_ROUTES from "./util/Route";
import { ROLES, generateRoutes, isLogin } from "./util/functions";
import useHttp from "./hooks/use-http";
import CONSTANTS from "./util/constant/CONSTANTS";
import useLocalStorage from "./hooks/useLocalStorage";
function App() {
  const [admindetails, setAdmindetails] = useState({})
  const [profile, SetProfile] = useLocalStorage("profile", {
    role: ROLES.Admin,
  });
  const api = useHttp()
  useEffect(() => {
    // console.log(!isLogin());
    if (!isLogin()) {
      return;
    }

    const GET_MY_PROFILE_API = { ...CONSTANTS.API.getMe }

    api.sendRequest(GET_MY_PROFILE_API, (res) => {
      setAdmindetails(res?.data)
    })


  }, [isLogin])


  const router = createBrowserRouter(
    generateRoutes(ALL_ROUTES({
      admindetails,
      data: profile,
      profile,
      SetProfile,
    }), profile?.role)
  );
  return <RouterProvider router={router} />;
}

export default App;
